import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { KpiChart } from '@app/models/kpi-chart';
import { KpiChartGroup } from '@app/models/kpi-chart-group';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit {
  @Input() chart: KpiChartGroup;
  max: number;
  min: number;
  sum: number;
  graphHeight = 200;
  roundOffDif: number;
  adjustToRoundOff: number;
  chartItems: KpiChart[];
  constructor() { }

  ngOnInit(): void {
    if (this.chart && this.chart.ChartItems) {
      console.log(this.chart);
      this.max = Math.max.apply(Math, this.chart.ChartItems.map(function (o) { return o.ChartValue; }));
      this.min = Math.min.apply(Math, this.chart.ChartItems.map(function (o) { return o.ChartValue; }));
      this.sum = this.chart.ChartItems.reduce((prev, cur) => prev + cur.ChartValue, 0);

      if (this.max % 10 === 0) {
        this.roundOffDif = 0;
        this.adjustToRoundOff = 0;
      } else {
        const mod = this.max % 10;
        this.roundOffDif = 10 - mod;
        this.max = this.max + this.roundOffDif;
      }

      console.log(this.max);
      this.chart.ChartItems.map(item => {
        item.GraphValue = item.ChartValue;
        item.ChartValue = ((this.graphHeight / this.max) * item.ChartValue);
        console.log(item.ChartValue);
      });

      this.chartItems = this.chart.ChartItems;
    }
  }
  getStyle() {
    const style = '{\'transform\': \'rotate(90deg)\'}';
    return style;
  }
}
@NgModule({
  declarations: [BarChartComponent],
  exports: [BarChartComponent],
  imports: [
    CommonModule,
    LinkModule,
  ]
})
export class BarChartModule { }
